// extracted by mini-css-extract-plugin
module.exports = {"hero":"hero-module--hero--UDsR4","img":"hero-module--img--2Qmz-"};